<aside class="sidebar" [class.collapsed]="sidebarService.isCollapsed()">
  <!-- Logo -->
  <div class="logo">
    @if (!sidebarService.isCollapsed()) {
      <img src="assets/images/logos/company_logo_with_name.svg" alt="Company Logo" />
    } @else {
      <img src="assets/images/logos/company_logo_icon.svg" alt="Company Logo" />
    }
  </div>

  <!-- Menu -->
  <ul class="menu">
    @for (item of menuItems; track item.labelKey; let i = $index) {
      <li
        [routerLink]="item.route"
        routerLinkActive="active-link"
        [pTooltip]="sidebarService.isCollapsed() ? (item.labelKey | translate) : ''"
      >
        <span class="flex items-center gap-4">
          <i class="pi {{ item.icon }} link-icon"></i>
          @if (!sidebarService.isCollapsed()) {
            <span class="label">
              {{ item.labelKey | translate }}
            </span>
          }
        </span>
      </li>
    }
  </ul>

  <!-- profile section -->
  <div class="profile-section" [ngClass]="{ '!px-2': sidebarService.isCollapsed() }">
    <p-select
      [options]="translateService.langOption"
      [ngModel]="translateService.selectedLanguage$ | async"
      (onChange)="translateService.setLanguage($event.value.value)"
      appendTo="body"
      optionLabel="name"
      class="w-full !border-none !shadow-none !bg-transparent"
    >
      <ng-template #selectedItem let-selectedOption>
        <div
          class="flex items-center gap-2"
          [ngClass]="{ 'justify-center': sidebarService.isCollapsed() }"
        >
          <img [src]="translateService.selectedLanguage.image" class="w-[18px]" alt="Flag" />
          @if (!sidebarService.isCollapsed()) {
            <div class="text-xs font-medium">{{ selectedOption.name }}</div>
            <i class="pi pi-angle-down dropdown-profile-arrow"></i>
          }
        </div>
      </ng-template>
      <ng-template let-lang #item>
        <div class="flex items-center gap-2">
          <img [src]="lang.image" class="w-[18px]" [alt]="lang.name" />
          @if (!sidebarService.isCollapsed()) {
            <div class="text-sm">{{ lang.name }}</div>
          }
        </div>
      </ng-template>
    </p-select>

    <!-- // notification -->
    @if (false) {
      <div class="menu !px-0">
        <li
          class="h-[36px]"
          routerLinkActive="active-link"
          [routerLink]="['notifications']"
          [pTooltip]="sidebarService.isCollapsed() ? ('sidebar.notifications' | translate) : ''"
        >
          <span class="flex items-center gap-4">
            <i class="pi pi-bell !text-sm text-primary"></i>
            @if (!sidebarService.isCollapsed()) {
              <span class="label">
                <span class="text-neutral-700 font-medium text-sm">{{
                  'sidebar.notifications' | translate
                }}</span>
              </span>
            }
          </span>
        </li>
      </div>
    }

    <div
      class="profile-settings relative"
      (click)="op.toggle($event)"
      [ngClass]="{ '!p-1 justify-center': sidebarService.isCollapsed() }"
    >
      <!-- <img src="assets/images/profile/dummy-profile.png" alt="Profile Picture" /> -->
      <div
        class="user-profile-circle border border-gray-200 !text-xs flex items-center justify-center"
      >
        {{ getUserInitial() }}
      </div>
      @if (!sidebarService.isCollapsed()) {
        <div class="profile-info">
          <span class="profile-name">{{ userData()?.name }}</span>
          <span class="profile-email">{{ userData()?.email }}</span>
        </div>
        <i class="pi pi-code absolute right-[18px]"></i>
      }
    </div>
    <p-popover #op>
      <ul class="profile-dialog p-1">
        <li>
          <i class="pi pi-user"></i>
          <span>Profile</span>
        </li>
        <li>
          <i class="pi pi-cog"></i>
          <span>Settings</span>
        </li>
        <li (click)="onLogOut()">
          <i class="pi pi-power-off"></i>
          <span>Logout</span>
        </li>
      </ul>
    </p-popover>
  </div>
</aside>
